












































































import { Integration, IntegrationOutputType } from '@/types';
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import IntegrationIcon from './IntegrationIcon.vue';
import IntegrationsEdit from './IntegrationsEdit.vue';

@Component({
  components: {
    IntegrationsEdit,
    IntegrationIcon,
  },
})
export default class IntegrationsList extends Vue {
  @Getter private hasPermission: any;

  @Prop({ default: () => [] }) private integrations!: Array<Partial<Integration>>;
  @Prop({ default: () => [] }) private integrationTypes!: object[];
  @Prop({ default: IntegrationOutputType.STREAMING }) private outputType!: IntegrationOutputType;

  private openedItemIndex: number | null = null;

  private get canAddIntegrations(): boolean {
    return (!!(this.integrations[this.integrations.length - 1] && this.integrations[this.integrations.length - 1].id) || !this.integrations.length);
  }

  private addIntegration() {
    // this.integrations.push();
    this.$emit('add:integration', { name: '', type: '', output_type: this.outputType, enabled: true });
    this.openedItemIndex = this.integrations.length - 1;
  }

  private editIntegration(integrationIndex: number) {
    this.openedItemIndex = integrationIndex;
  }

  private toggleEnabled(integrationIndex: number) {
    this.$emit('toggleEnabled', integrationIndex);
  }

  private removeIntegration(integrationIndex: number) {
    this.$emit('removeIntegration', integrationIndex);
  }

  private closeAccordion() {
    this.openedItemIndex = null;
  }

  private get openedIntegration() {
    if (typeof this.openedItemIndex !== 'number') {
      return null;
    }

    return this.integrations[this.openedItemIndex];
  }
}
